import { AsyncThunkConfigWithRejectValue, createAsyncThunk } from '@/redux/createAsyncThunk';
import { deleteAccount } from '@/redux/modules/account/deleteAccount/deleteAccount.api';
import { logOutBidder } from '@/redux/modules/account/logout/logout.actions';
import { getDeployment } from '@/redux/modules/config';
import noop from '@/utils/noop';

import { SubmitDeleteAccountParams } from './deleteAccount.types';

export const submitDeleteAccount = createAsyncThunk<void, SubmitDeleteAccountParams, AsyncThunkConfigWithRejectValue>(
    'la/ui/deleteAccount/submitDeleteAccount',
    async ({ appleCode, bidderId, token }, { dispatch, getState, rejectWithValue }) => {
        try {
            const state = getState();
            const deployment = getDeployment(state);

            const response = await deleteAccount({
                appleCode,
                bidderId,
                deployment,
                token,
            });

            // Only logout if the delete was successful
            if (!response.error) {
                dispatch(logOutBidder());
            }
        } catch (error) {
            const publishedError = typeof error === 'string' ? new Error(error) : (error as Error);
            return rejectWithValue(publishedError);
        }
    }
);

export const resetAccountDeleteSlice = createAsyncThunk('la/ui/deleteAccount/resetAccountDeleteSlice', noop);
